import styled from "styled-components";

export const MusicInstrumentFormStyled = styled.div`
  .form_title {
    margin-bottom: 19px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .sub_title {
    margin-bottom: 26px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_BOLD};
  }
  .body_form_campaign {
    .input_type_wrap {
      margin-bottom: 20px;
      display: flex;
      width: 100%;
      .itw_left_box {
        width: 20%;
        display: flex;
        align-items: center;
      }
      .itw_right_box {
        width: 40%;
      }
    }
    .input_warp {
      margin-bottom: 20px;
      display: flex;
      width: 100%;
      &.mt30 {
        margin-top: 30px;
      }
      .left_box {
        width: 20%;
        display: flex;
        align-items: center;
      }
      .right_box {
        width: 80%;
        display: flex;
        align-items: flex-start;
        &.center {
          align-items: center;
        }
        .w20 {
          width: 20%;
        }
        .w50 {
          width: 50%;
        }
      }
    }
    .row_wrap {
      display: flex;
      align-items: center;
      .row_left {
        width: 40%;
        .input_warp {
          display: flex;
          column-gap: 200px;
          white-space: nowrap;
        }
      }
      .row_right {
        width: 30%;
        display: flex;
        white-space: nowrap;
        align-items: center;
        .input_warp {
          display: flex;
          column-gap: 100px;
          white-space: nowrap;
        }
      }
    }
    .line {
      margin: 21px 0;
      flex: 1;
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_11};
    }
    .btn_zone {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      column-gap: 10px;
      .w120 {
        width: 120px;
      }
    }
  }
`;
